/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

export const REQUESTED_ACCOUNT_HISTORY = 'REQUESTED_ACCOUNT_HISTORY';
export const requestedAccountHistory = (beginDate, endDate) => {
  return {
    type: REQUESTED_ACCOUNT_HISTORY,
    beginDate,
    endDate
  };
};

export const RECEIVED_ACCOUNT_HISTORY = 'RECEIVED_ACCOUNT_HISTORY';
export const receivedAccountHistory = (history) => {
  return {
    type: RECEIVED_ACCOUNT_HISTORY,
    history
  };
};

export const ERROR_ACCOUNT_HISTORY = 'ERROR_ACCOUNT_HISTORY';
export const errorAccountHistory = (error, beginDate, endDate) => {
  return {
    type: ERROR_ACCOUNT_HISTORY,
    error,
    beginDate,
    endDate
  };
};
